import { useEffect, useState } from "react";

// Breakpoints roughly aligned with common device widths.
// mobile:  < 768px
// tablet:  768px - 1023px
// desktop: >= 1024px
const MOBILE_MAX = 767;
const TABLET_MAX = 1023;

const getWidth = () =>
  typeof window !== "undefined" ? window.innerWidth : 1280;

const compute = (width) => ({
  width,
  isMobile: width <= MOBILE_MAX,
  isTablet: width > MOBILE_MAX && width <= TABLET_MAX,
  isDesktop: width > TABLET_MAX,
});

/**
 * Returns the current responsive breakpoint flags and updates on window resize.
 */
export const useBreakpoint = () => {
  const [state, setState] = useState(() => compute(getWidth()));

  useEffect(() => {
    const handleResize = () => setState(compute(getWidth()));
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return state;
};

export default useBreakpoint;
